import { Subject, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { filter, map } from "rxjs/operators";

interface BroadcastEvent<T = unknown> {
    key: string;
    data?: T;
}

@Injectable()
export class BroadcastService {
    private static _eventBus = new Subject<BroadcastEvent>();

    public static broadcast<T>(key: string, data?: T): void {
        this._eventBus.next({ key, data });
    }

    public static on<T>(key: string): Observable<T> {
        return this._eventBus.asObservable().pipe(
            filter((event) => event.key === key),
            map((event) => event.data as T),
        );
    }
}
